import React from 'react';
import './DesktopApp.css'; // Optional: create a CSS file for styling

const DesktopApp = () => {
  const EXE_DOWNLOAD_URL = 'https://your-release-url/Ventrai-Setup.exe'; // Replace with actual URL

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = EXE_DOWNLOAD_URL;
    link.download = 'Ventrai-Setup.exe';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="desktop-app-container">
      <div className="desktop-app-content">
        <h1>Download Ventrai Desktop</h1>
        <p>Get started with Ventrai on your desktop. Download the Windows executable to begin your mentorship journey.</p>
        
        <button 
          onClick={handleDownload} 
          className="download-btn"
          aria-label="Download Ventrai .exe for Windows"
        >
          ⬇️ Download for Windows (.exe)
        </button>

        <div className="system-requirements">
          <h2>System Requirements</h2>
          <ul>
            <li>Windows 7 or higher</li>
            <li>1 GB RAM minimum</li>
            <li>100 MB free disk space</li>
            <li>Internet connection required</li>
          </ul>
        </div>

        <div className="installation-guide">
          <h2>Installation Guide</h2>
          <ol>
            <li>Click the download button above</li>
            <li>Run the Ventrai-Setup.exe installer</li>
            <li>Follow the installation wizard</li>
            <li>Launch Ventrai from your Start menu or desktop shortcut</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default DesktopApp;
